export const en_contacts = {
  main: "Find Us By Below Details",
  location: "169-0051 1-22-3 Nishi-Waseda, Shinjuku, Tokyo",
  phone: "+81 80 4905 7900",
  mail: "{address}"
}